// extracted by mini-css-extract-plugin
export default {"circle":"MenteeDetails_circle__oXr5i","root":"MenteeDetails_root__K+d5D"};